import { z } from 'zod'
export const Qc8110GetResultSchema = z.object({
  lotNo: z.string(),
  date: z.coerce.date(),
  byName: z.string(),
  remark: z.string().optional(),
  qty: z.number(),
  type: z.number(),
  status: z.number(),
  itemId: z.number().optional(),
  itemCode: z.string().optional(),
  itemName: z.string().optional(),
})

export type Qc8110GetResultModel = z.input<typeof Qc8110GetResultSchema>
